import { Labels } from '../../shared-components/global/labels';

Labels.set(
    'ui-skip-to-content',
    'linkLabel',
    'Перейти к основному содержимому'
);
